import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchXFactorSlice = createAsyncThunk("fetchXFactorSlice", async (company) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`xf/graph?company=${company}`, config);

	return response.data.data;
});

const xfactorGraphSlice = createSlice({
	name: "xfactorGraph",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchXFactorSlice.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchXFactorSlice.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchXFactorSlice.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default xfactorGraphSlice.reducer;
